import React from 'react'; 

let GlobalRulesContext = React.createContext(null);

export default GlobalRulesContext;